export enum Page {
  GameType = 'GameType',
  SessionData = 'SessionData',
  StrikeZone = 'StrikeZone',
  GameSettings = 'GameSettings',
}
